export default {"src":"/_next/static/media/horseIcon.af41f4c7.svg","height":76,"width":57};